import { render, staticRenderFns } from "./CaseBeneficiaries.vue?vue&type=template&id=00273e90"
import script from "./CaseBeneficiaries.vue?vue&type=script&lang=js"
export * from "./CaseBeneficiaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports